export default __webpack_public_path__ + "dc782c87a723acc86809c533a11e5a75.png";